var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('button', {
    staticClass: "pure-button in-activity-button",
    attrs: {
      "aria-label": "Save",
      "tabindex": "8"
    }
  }, [_c('save-icon')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }